var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgImageFilled = function SvgImageFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M6.998 3.746a3.252 3.252 0 0 0-3.252 3.252v10.004c0 .061.002.122.005.182l3.3-3.3a2.75 2.75 0 0 1 3.89 0l1.057 1.059 4.06-4.06a2.751 2.751 0 0 1 3.89 0l.306.307V6.998a3.252 3.252 0 0 0-3.252-3.252H6.998Zm14.756 3.252a4.752 4.752 0 0 0-4.752-4.752H6.998a4.752 4.752 0 0 0-4.752 4.752v10.004a4.752 4.752 0 0 0 4.752 4.752h10.004a4.752 4.752 0 0 0 4.752-4.752V6.998Zm-1.5 6.313-1.367-1.367a1.25 1.25 0 0 0-1.769 0l-4.059 4.06 4.238 4.237a3.252 3.252 0 0 0 2.957-3.239v-3.69Zm-5.066 6.943L9.88 14.945a1.25 1.25 0 0 0-1.769 0l-3.835 3.836a3.249 3.249 0 0 0 2.722 1.473h8.19ZM5.248 7.498a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Zm2.25-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "m9.88 14.945 5.308 5.309h-8.19a3.249 3.249 0 0 1-2.722-1.473l3.835-3.835a1.25 1.25 0 0 1 1.769 0ZM18.887 11.944l1.367 1.367v3.691c0 1.697-1.3 3.09-2.957 3.239l-4.238-4.238 4.06-4.059a1.25 1.25 0 0 1 1.768 0ZM6.747 7.498a.75.75 0 1 1 1.502 0 .75.75 0 0 1-1.502 0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImageFilled);
export default ForwardRef;